import { Input, Label } from 'reactstrap'

type Props = {
  isCheckDailyReportUse: boolean
  onChange: (checked: boolean) => void
}

export const UseDailyReportCheckBox = ({ isCheckDailyReportUse, onChange }: Props) => {
  return (
    <div className="form-check">
      <Input
        className="form-check-input"
        id="daily-report"
        checked={isCheckDailyReportUse}
        type="checkbox"
        onChange={e => onChange(e.target.checked)}
      />
      <Label className="form-check-label mb-0" for="daily-report">
        日報実績を利用
      </Label>
    </div>
  )
}
